export { default as IconArbeitUndWirtschaft } from './arbeit-und-wirtschaft'
export { default as IconDigitalisierung } from './digitalisierung'
export { default as IconEnergie } from './energie'
export { default as IconGlobaleVerantwortung } from './globale-verantwortung'
export { default as IconLebenUndWohnen } from './leben-und-wohnen'
export { default as IconMobilitaetUndInfrastruktur } from './mobilitaet-und-infrastruktur'
export { default as IconPartizipationUndTeilhabe } from './partizipation-und-teilhabe'
export { default as IconUmweltUndRessourcenschutz } from './umwelt-und-ressourcenschutz'
export { default as IconWetterUndKlima } from './wetter-und-klima'
export { default as IconArbeit } from './arbeit'
export { default as IconSicherheitUndOrdnung } from './sicherheit-und-ordnung'
export { default as IconOepnv } from './oepnv'